import { render, staticRenderFns } from "./TwoColumnsPageContainer.vue?vue&type=template&id=48613d50"
import script from "./TwoColumnsPageContainer.vue?vue&type=script&lang=js"
export * from "./TwoColumnsPageContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports